var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFichaTecnica({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.734,
    height: 24.123,
    viewBox: "0 0 19.734 24.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fffbf3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documento",
    transform: "translate(-4.6 -6.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7867",
    "data-name": "Path 7867",
    className: "cls-1",
    d: "M23.421,6.9H5.513a.918.918,0,0,0-.913.913h0v22.3a.918.918,0,0,0,.913.913H23.421a.918.918,0,0,0,.913-.913h0V7.835a.9.9,0,0,0-.913-.935Zm-.326,22.907H5.839V8.161H23.095V29.807Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7868",
    "data-name": "Path 7868",
    className: "cls-1",
    d: "M22.13,31.961H33.258a.63.63,0,0,0,0-1.261H22.13a.63.63,0,0,0,0,1.261Z",
    transform: "translate(-13.227 -18.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7869",
    "data-name": "Path 7869",
    className: "cls-1",
    d: "M22.13,50.761H33.258a.63.63,0,0,0,0-1.261H22.13a.63.63,0,0,0,0,1.261Z",
    transform: "translate(-13.227 -33.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7870",
    "data-name": "Path 7870",
    className: "cls-1",
    d: "M22.13,69.461H33.258a.63.63,0,1,0,0-1.261H22.13a.631.631,0,0,0-.63.63A.617.617,0,0,0,22.13,69.461Z",
    transform: "translate(-13.227 -47.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7871",
    "data-name": "Path 7871",
    className: "cls-1",
    d: "M22.13,89.661H33.258a.63.63,0,1,0,0-1.261H22.13a.63.63,0,0,0,0,1.261Z",
    transform: "translate(-13.227 -63.788)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFichaTecnica);
export default __webpack_public_path__ + "static/media/ficha-tecnica.639d6a641c2c80d2c916bf565e6e3c7e.svg";
export { ForwardRef as ReactComponent };